module.exports = __webpack_public_path__ + "img/bolha.53608962.svg";